export default {
  title: 'Shuttle Riders',
  assignments: 'Assignments',
  associations: 'Associations',
  assignRidersWithExcel: 'Assign Riders with Excel',
  rider: 'Rider',
  uniqueId: 'Unique ID',
  routeGroup: 'Route Group',
  route: 'Route',
  stop: 'Stop',
  distanceToStop: 'Distance to stop',
  timeOnShuttle: 'Time on shuttle',
  assignmentsColumn: 'Assignment',
  email: 'Email',
  company: 'Company',
  department: 'Department',
  schedule: 'Schedule',
  campus: 'Campus',
  noAssociation: 'No Association',
  notAssigned: 'None',
  allCompanies: 'All Companies',
  allDepartments: 'All Departments',
  allRouteGroups: 'All Route Groups',
  allSchedules: 'All Schedules',
  variableShift: 'Variable Shift',
  fixedShift: 'Fixed Shift',
  showOnlyStopsWithinWalkingDistance: 'Show only stops within walking distance',
  pendingRegularAssignmentBanner:
    'To enable daily recurring route usage for riders with a regular schedule, you need to review the associated routes and manually assign the riders. Currently, {0} {1} are pending regular assignment.',
  showingPendingRegularAssignment: 'Showing {0} {1} who are pending regular assignment.',
  showAll: 'Show all',
  assign: 'Assign',
  assignSuccess: 'Riders assigned successfully.',
  assignToAssociatedGroups: 'Assign to associated groups',
  sendForConfirmation: 'Send for Confirmation',
  addToGroup: 'Add to Group',
  forAPeriod: 'For a Period',
  forRegularUse: 'For Regular Use',
  startingFrom: 'Starting from',
  until: 'Until',
  cancel: 'Cancel',
  confirm: 'Confirm',
  deleteAssignment: 'Delete Assignment',
  assignRegularConfirm:
    'Please confirm if you want to assign the selected riders to their associated route groups for regular use.',
  addToGroupSuccess: '{0} riders have been successfully added to the selected group.',
  selectRouteGroup: 'Select Route Group',
  riderSingular: 'rider',
  riderPlural: 'riders',
  assigned: 'Assigned',
  startDateRequired: 'Start date is required.',
  endDateRequired: 'End date is required for a period assignment.',
  endDateBeforeStart: 'End date cannot be earlier than start date.',
  startDateBeforeToday: 'Start date cannot be earlier than today.',
  assignmentsTabPlaceholder: 'Assignments tab is coming soon.',
  startDay: 'Start Date',
  endDay: 'End Date',
  ongoing: 'Ongoing',
  deleteAssignmentConfirm: 'Are you sure you want to delete the selected assignments?',
  deleteAssignmentSuccess: 'Assignments deleted successfully.',
  noAssignments: 'No assignments found for the selected period.',
  noAssociations: 'No associations found for the selected criteria.',
  assignPartialSkip: '{0} riders were assigned. {1} riders were skipped because they have no associated route or stop.',
  noAssociatedRoutesTitle: 'No Associated Routes',
  noAssociatedRoutesMessage:
    '{0} riders have been successfully assigned to their associated routes.<br><br>However, {1} riders could not be assigned, as no associated routes were found for them. You’ll need to manually edit their assignment by selecting an appropriate route and stop.',
  viewAssignmentsWithNoRoutes: 'View Assignments with No Routes',
  assignDisabledNoRoute:
    'None of the selected riders have all required association fields (route group, route, stop, and schedule) to be assigned. Add them to a route group or complete their association first.',
};
